import { useContext } from 'react';
import { UserContext } from 'routes/login/userContext';
import { reduce } from 'ramda';

export default function useHasPermission<T extends string | string[]>({
  toCheck,
}: {
  toCheck: T;
}): boolean | boolean[] {
  const userContext = useContext(UserContext);
  const permissions = userContext.role?.permissions || [];
  const userPermissionMap = reduce(
    (pMap: any, p) => {
      pMap[p] = true;
      return pMap;
    },
    {},
    permissions
  );
  const check = (p: unknown): boolean => !p || !!userPermissionMap[p as string];
  return Array.isArray(toCheck) ? toCheck.map(check) : check(toCheck);
}
